"use client";

import { resizeImageUrl } from "@lib/util/images";
import Image from "next/image";
import { useState } from "react";
import "swiper/css";
import { Thumbs } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import ImagePreviewGallery from "../image-preview-group";

type ImageGalleryProps = {
  images: { url: string }[];
};

const ImageGallery = ({ images }: ImageGalleryProps) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);

  if (!images.length) return null;

  return (
    <div className="w-full max-w-lg mx-auto">
      <ImagePreviewGallery images={images} thumbsSwiper={thumbsSwiper} />
      <Swiper
        modules={[Thumbs]}
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={4}
        watchSlidesProgress
        className="mt-4"
      >
        {thumbsSwiper &&
          images.map((image, index) => (
            <SwiperSlide key={index}>
              <Image
                width={80}
                height={80}
                src={resizeImageUrl(image.url, 80, 80)}
                loading="eager"
                alt={`thumb-${index}`}
                className="object-cover cursor-pointer rounded-md border-1 swiper-slide-thumb-active:border-primary-500"
              />
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};

export default ImageGallery;
